import { Dispatch, FC, SetStateAction } from "react";
import Select, { StylesConfig } from "react-select";
import { ElectionType, ListName } from "./types";

interface Props {
  copy: Record<string, string | undefined>;
  electionTypes: ElectionType[];
  listNames: ListName[];
  selectedListName: ListName | null;
  selectedElection: ElectionType | null;
  setSelectedElectionType: Dispatch<SetStateAction<ElectionType | null>>;
  setSelectedListName: Dispatch<SetStateAction<ListName | null>>;
  showElectedCandidatesOnly: boolean;
}

const selectStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    borderRadius: 0,
    padding: "5px",
  }),
  dropdownIndicator: (styles) => ({ ...styles, color: "#801f86" }),
  indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    color: isFocused || isSelected ? "white" : "#801f86",
    backgroundColor: isFocused || isSelected ? "#801f86" : "white",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#801f86",
    fontWeight: "bold",
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 50,
  }),
};

export const CandidateListHeader: FC<Props> = ({
  copy,
  electionTypes,
  listNames,
  selectedElection,
  setSelectedElectionType,
  selectedListName,
  setSelectedListName,
  showElectedCandidatesOnly,
}) => {
  return (
    <div>
      <div className="candidate-list__header">
        <div className="candidate-list__header__filters">
          <div className="candidate-list__header__filters__election-type">
            <h6>{showElectedCandidatesOnly
              ? copy.candidateListElectionTypeMenuLabelPostElection
              : copy.candidateListElectionTypeMenuLabel
            }
            </h6>
            <Select
              className="candidate-list__header__filters__election-type__select"
              options={electionTypes}
              value={selectedElection}
              onChange={(e) => {
                if ((e as ElectionType) === selectedElection) return;

                setSelectedElectionType(e as ElectionType);
                setSelectedListName(null);
              }}
              placeholder={showElectedCandidatesOnly
                ? copy.candidateListElectionTypeMenuPlaceholderPostElection
                : copy.candidateListElectionTypeMenuPlaceholder
              }
              styles={selectStyles}
            />
          </div>
          {!showElectedCandidatesOnly && (
            <div className="candidate-list__header__filters__list-name">
              <h6>{copy.candidateListListNameMenuLabel}</h6>
              <Select
                className="candidate-list__header__filters__list-name__select"
                options={listNames}
                value={selectedListName}
                onChange={(e) => {
                  setSelectedListName(e as ListName);
                }}
                placeholder={copy.candidateListListNameMenuPlaceholder}
                styles={selectStyles}
                isDisabled={!selectedElection}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
